
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M104.187 16.104l14.83 16.304 21.156-6.179 4.876 16.38-46.3 47.945-14.01-13.528-.352-.333a22.81 22.81 0 00-15.943-6.086 22.812 22.812 0 00-16.062 6.984 22.812 22.812 0 00-6.419 16.295 22.81 22.81 0 006.639 15.721l.345.34L82.15 138.15l.37.423c.376.42.77.829 1.181 1.226a23.31 23.31 0 0016.652 6.56 23.308 23.308 0 0016.073-6.793l.34-.344 57.625-59.675 8.333 5.868L170.13 103.5l10.73 19.25-19.194 10.831 1.316 22-21.993 1.43-8.36 20.393-20.436-8.254-16.38 14.746-14.83-16.304-21.156 6.179-6.288-21.124-21.742-3.613 3.5-21.76-18.02-12.688L29.87 96.5 19.14 77.25l19.194-10.831-1.316-22 21.993-1.43 8.36-20.393 20.436 8.254 16.38-14.746zm77.727 21.991c5.165 4.988 5.308 13.218.321 18.382l-72.94 75.531c-4.987 5.165-13.216 5.308-18.381.321a13.123 13.123 0 01-1.14-1.251l-29.614-28.6c-4.966-4.795-5.104-12.708-.308-17.674 4.795-4.966 12.709-5.104 17.675-.309l21.478 20.74 64.527-66.819c4.988-5.164 13.218-5.308 18.382-.32z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    